export default "assets/images/icons/external-224260a2.svg";